import React from "react";
import { FaSquareFacebook } from "react-icons/fa6";
import "./Join.css";

const Join = () => {
  return (
    <div className="container text-center py-5">
      <button className="btn notero-button">Amar Net Bill Community</button>
      <h1 className="py-3 fw-bolder">
        Stay Connected <span className="text-color">With Us</span>
      </h1>

      <div
        id="join-border"
        className="d-flex flex-column w-75 mx-auto flex-lg-row gap-4 rounded-4 m-1 p-4 text-center"
      >
        <div className="flex-fill">
          <div className="d-flex flex-column flex-md-row align-items-center justify-content-around gap-3">
            <div id="github">
              <svg width="0" height="0">
                <linearGradient
                  id="fbGradient"
                  x1="0%"
                  y1="0%"
                  x2="100%"
                  y2="100%"
                >
                  <stop offset="0%" stopColor="#6953d3" />
                  <stop offset="33%" stopColor="#8566f1" />
                  <stop offset="66%" stopColor="#a14eee" />
                  <stop offset="100%" stopColor="#f98085" />
                </linearGradient>
              </svg>

              <FaSquareFacebook
                style={{
                  fontSize: "100px",
                  fill: "url(#fbGradient)"
                }}
              />
            </div>
            <div className="lh-1">
              <h1 className="fw-bolder">Join Our Facebook Community</h1>
              <small>
                Connect with members, share ideas, and get the latest updates
              </small>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Join;
